import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
// import ReactPaginate from 'react-paginate'
import './PendingRequests.css'
import { ApprovedSMS } from '../../models/Package'
import PackageService from '../../../api/super-admin/PackageService'
import Swal from 'sweetalert2'

interface Errors {
  sender_id: string
  api_key: string
  // secret_key: string
}

function PendingRequests() {
  const [showAddEditPopup, setShowAddEditPopup] = useState<boolean>(false)
  const [showDetailsPopup, setShowDetailsPopup] = useState<boolean>(false)
  const [pendingSMSList, setPendingSMSList] = useState<ApprovedSMS[]>([] as ApprovedSMS[])
  const [companySMSDetail, setCompanySMSDetail] = useState<ApprovedSMS>({} as ApprovedSMS)
  const [formData, setFormData] = useState<any>({
    id: undefined,
    sender_id: '',
    api_key: '',
    // secret_key: '',
  })
  const [formErrors, setFormErrors] = useState<Errors>({
    sender_id: '',
    api_key: '',
    // secret_key: '',
  })

  useEffect(() => {
    getPendingSMSList()
  }, [])

  const getPendingSMSList = () => {
    PackageService.getPendingSMSList().then(
      (res: any) => {
        if (res?.data?.success) {
          setPendingSMSList(res?.data?.data)
        } else {
          toast.error(res?.data?.message, { theme: 'dark' })
          setPendingSMSList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' })
      }
    )
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }))
  }

  const clearFormData = () => {
    setFormData({
      sender_id: '',
      api_key: '',
      // secret_key: '',
    })
  }

  const handleViewDetails = (id: number) => {
    PackageService.getCompanySMSDetails(id).then(
      (res: any) => {
        if (res?.data?.success) {
          setCompanySMSDetail(res?.data?.data)
          setShowDetailsPopup(true)
        } else {
          toast.error(res?.data?.message, { theme: 'dark' })
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' })
      }
    )
  }

  const handleDecline = (id: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to decline this request?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, decline it!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        PackageService.declineSMSRequest(id).then(
          (res: any) => {
            if (res?.data?.success) {
              toast.success(res?.data?.message, { theme: 'dark' })
              getPendingSMSList()
            } else {
              toast.error(res?.data?.message, { theme: 'dark' })
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, { theme: 'dark' })
          }
        )
      }
    })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    // Clear previous errors
    setFormErrors({
      sender_id: '',
      api_key: '',
      // secret_key: '',
    })

    // Validation checks
    let errors: Errors = {
      sender_id: '',
      api_key: '',
      // secret_key: '',
    }

    let hasErrors = false

    if (!formData.sender_id.trim()) {
      errors.sender_id = 'Sender ID is required'
      hasErrors = true
    }
    if (!formData.api_key.trim()) {
      errors.api_key = 'API Key is required'
      hasErrors = true
    }
    // if (!formData.secret_key.trim()) {
    //   errors.secret_key = 'Secret Key is required'
    //   hasErrors = true
    // }

    if (hasErrors) {
      setFormErrors(errors)
      return
    }

    let data: any = formData
    PackageService.approveSMS(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, { theme: 'dark' })
          setShowAddEditPopup(false)
          clearFormData()
          getPendingSMSList()
        } else {
          toast.error(res?.data?.message, { theme: 'dark' })
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' })
      }
    )
  }

  const handleEdit = (id: number) => {
    setFormData({
      id: id,
      sender_id: '',
      api_key: '',
      // secret_key: '',
    })
    setShowAddEditPopup(true)
  }

  return (
    <>
      {/* Table */}
      <div className='col-lg-12' style={{ marginTop: 25 }} />
      <div className='mb-5'>
        <div className='table-responsive'>
          <div className='d-flex justify-content-between w-100 p-3 pb-2'>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Company Name</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Sender ID</span>
            </td>
            {/* <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Balance</span>
            </td>
            <td className='d-flex w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>SMS Limit</span>
            </td> */}
            <td className='text-end w-lg-25'>
              <span className='text-dark fw-bold d-block fs-5 text-muted'>Action</span>
            </td>
          </div>
          {pendingSMSList.map(
            (approvedSMS: ApprovedSMS, index: number) =>
              approvedSMS.status === 3 && (
                <div
                  className='p-3 py-2 mb-2 bg-white d-flex justify-content-between w-100'
                  key={index}
                  style={{ marginBottom: 20, borderRadius: 5 }}
                >
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.companyDetails.name}
                    </span>
                  </td>
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.sender_id}
                    </span>
                  </td>
                  {/* <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.balance}
                    </span>
                  </td>
                  <td className='d-flex w-lg-25'>
                    <span className='text-dark fw-bold d-block fs-5 d-flex align-items-center'>
                      {approvedSMS.sms_limit}
                    </span>
                  </td> */}
                  <td className='d-flex justify-content-end w-lg-25'>
                    <button
                      style={{
                        backgroundColor: 'blue',
                        color: 'white',
                        fontWeight: 'bold',
                        borderRadius: 5,
                      }}
                      type='button'
                      onClick={() => handleViewDetails(approvedSMS.id)}
                      className='btn btn-sm mx-1'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      title='Details'
                    >
                      Details
                    </button>
                    <button
                      style={{
                        backgroundColor: 'limegreen',
                        color: 'white',
                        fontWeight: 'bold',
                        borderRadius: 5,
                      }}
                      type='button'
                      onClick={() => handleEdit(approvedSMS.id)}
                      className='btn btn-sm mx-1'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      title='Edit'
                    >
                      Approve
                    </button>
                    <button
                      style={{
                        backgroundColor: 'red',
                        color: 'white',
                        fontWeight: 'bold',
                        borderRadius: 5,
                      }}
                      type='button'
                      onClick={() => handleDecline(approvedSMS.id)}
                      className='btn btn-sm mx-1'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      title='Decline'
                    >
                      Decline
                    </button>
                  </td>
                </div>
              )
          )}
          {pendingSMSList.length === 0 && (
            <p className='text-dark fw-bold d-block fs-5 text-muted' style={{textAlign:'center', marginTop:150}}>No Pending SMS Requests Available</p>
          )}
        </div>
      </div>

      {/* Add Edit Popup */}
      {showAddEditPopup && (
        <div
          className='modal fade show'
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex={-1}
        >
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='d-flex justify-content-between align-items-center w-100 mx-3'>
                <h5 style={{marginLeft:20}} className='modal-title'>Approve SMS</h5>
                <button
                  type='button'
                  className='btn-close'
                  onClick={() => setShowAddEditPopup(false)}
                  aria-label='Close'
                ></button>
              </div>
              <div className='modal-body'>
                <form onSubmit={handleSubmit}>
                  <div className='mb-3'>
                    <label htmlFor='sender_id' className='form-label'>
                      Sender ID
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      id='sender_id'
                      name='sender_id'
                      value={formData.sender_id}
                      onChange={handleInputChange}
                    />
                    {formErrors.sender_id && (
                      <div className='text-danger'>{formErrors.sender_id}</div>
                    )}
                  </div>
                  <div className='mb-3'>
                    <label htmlFor='api_key' className='form-label'>
                      API Key
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      id='api_key'
                      name='api_key'
                      value={formData.api_key}
                      onChange={handleInputChange}
                    />
                    {formErrors.api_key && (
                      <div className='text-danger'>{formErrors.api_key}</div>
                    )}
                  </div>
                  {/* <div className='mb-3'>
                    <label htmlFor='secret_key' className='form-label'>
                      Secret Key
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      id='secret_key'
                      name='secret_key'
                      value={formData.secret_key}
                      onChange={handleInputChange}
                    />
                    {formErrors.secret_key && (
                      <div className='text-danger'>{formErrors.secret_key}</div>
                    )}
                  </div> */}
                  <button type='submit' className='btn btn-primary'>
                    Approve
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Details Popup */}
      {showDetailsPopup && (
        <div
          className='modal fade show'
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex={-1}
        >
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='d-flex justify-content-between align-items-center w-100 mx-3'>
                <h5 style={{marginLeft:20}} className='modal-title'>Company SMS Details</h5>
                <button
                  type='button'
                  className='btn-close'
                  onClick={() => setShowDetailsPopup(false)}
                  aria-label='Close'
                ></button>
              </div>
              <div className='modal-body'>
                <div className='mb-3'>
                  <label className='form-label'>Company Name</label>
                  <input
                    type='text'
                    className='form-control'
                    value={companySMSDetail.companyDetails?.name}
                    readOnly
                  />
                </div>
                <div className='mb-3'>
                  <label className='form-label'>Sender ID</label>
                  <input
                    type='text'
                    className='form-control'
                    value={companySMSDetail.sender_id}
                    readOnly
                  />
                </div>
                {/* <div className='mb-3'>
                  <label className='form-label'>Balance</label>
                  <input
                    type='text'
                    className='form-control'
                    value={companySMSDetail.balance}
                    readOnly
                  />
                </div>
                <div className='mb-3'>
                  <label className='form-label'>SMS Limit</label>
                  <input
                    type='text'
                    className='form-control'
                    value={companySMSDetail.sms_limit}
                    readOnly
                  />
                </div> */}
              </div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-secondary'
                  onClick={() => setShowDetailsPopup(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PendingRequests
